export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              编辑精选专题合集，一站探索你感兴趣的影视世界
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {/* Item 1 */}
            <div className="group relative rounded-2xl overflow-hidden aspect-[4/3] cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinema%20collage%20with%20spaceships%20and%20distant%20galaxies%2C%20warm%20golden%20and%20crimson%20cosmic%20colors%2C%20cinematic%20lighting%2C%20film%20poster%20inspired%20art%2C%20clean%20composition%2C%20professional%20movie%20promotional%20design&width=800&height=600&seq=carousel-01&orientation=landscape"
                alt="科幻盛宴专题 - 西瓜影视焦点专题"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-primary-500/90 text-background-50 text-[10px] font-medium mb-2 whitespace-nowrap">热门专题</span>
                <h3 className="font-heading text-lg font-bold text-background-50 mb-1">科幻盛宴</h3>
                <p className="text-xs text-background-300">20部硬核科幻，开启星际之旅</p>
              </div>
            </div>

            {/* Item 2 */}
            <div className="group relative rounded-2xl overflow-hidden aspect-[4/3] cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20collage%20with%20mysterious%20shadows%20and%20dramatic%20lighting%2C%20noir%20atmosphere%2C%20warm%20amber%20tones%2C%20cinematic%20composition%2C%20film%20poster%20inspired%20design%2C%20clean%20professional%20look&width=800&height=600&seq=carousel-02&orientation=landscape"
                alt="烧脑特辑专题 - 西瓜影视焦点专题"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-500/90 text-background-950 text-[10px] font-medium mb-2 whitespace-nowrap">编辑精选</span>
                <h3 className="font-heading text-lg font-bold text-background-50 mb-1">烧脑特辑</h3>
                <p className="text-xs text-background-300">高能反转悬疑推理一次看够</p>
              </div>
            </div>

            {/* Item 3 */}
            <div className="group relative rounded-2xl overflow-hidden aspect-[4/3] cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20collage%20with%20soft%20cherry%20blossoms%20and%20warm%20spring%20lighting%2C%20pastel%20pink%20and%20golden%20tones%2C%20dreamy%20cinematic%20composition%2C%20film%20poster%20inspired%20design%2C%20clean%20professional%20look&width=800&height=600&seq=carousel-03&orientation=landscape"
                alt="韩剧热追专题 - 西瓜影视焦点专题"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-500/90 text-background-950 text-[10px] font-medium mb-2 whitespace-nowrap">追剧必备</span>
                <h3 className="font-heading text-lg font-bold text-background-50 mb-1">韩剧热追</h3>
                <p className="text-xs text-background-300">高分韩剧浪漫甜宠一网打尽</p>
              </div>
            </div>

            {/* Item 4 */}
            <div className="group relative rounded-2xl overflow-hidden aspect-[4/3] cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=Ancient%20Chinese%20martial%20arts%20movie%20collage%20with%20flowing%20silk%20and%20dramatic%20landscapes%2C%20warm%20golden%20and%20vermilion%20tones%2C%20cinematic%20lighting%2C%20historical%20drama%20aesthetic%2C%20film%20poster%20inspired%20design%2C%20clean%20professional%20look&width=800&height=600&seq=carousel-04&orientation=landscape"
                alt="国风剧场专题 - 西瓜影视焦点专题"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-primary-500/90 text-background-50 text-[10px] font-medium mb-2 whitespace-nowrap">独家策划</span>
                <h3 className="font-heading text-lg font-bold text-background-50 mb-1">国风剧场</h3>
                <p className="text-xs text-background-300">经典古装大戏国韵风华尽览</p>
              </div>
            </div>

            {/* Item 5 */}
            <div className="group relative rounded-2xl overflow-hidden aspect-[4/3] cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=Comedy%20movie%20collage%20with%20bright%20colorful%20fun%20atmosphere%2C%20warm%20sunny%20lighting%2C%20cheerful%20vibrant%20colors%2C%20cinematic%20composition%2C%20film%20poster%20inspired%20design%2C%20clean%20professional%20look&width=800&height=600&seq=carousel-05&orientation=landscape"
                alt="欢乐合辑专题 - 西瓜影视焦点专题"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-500/90 text-background-950 text-[10px] font-medium mb-2 whitespace-nowrap">解压必备</span>
                <h3 className="font-heading text-lg font-bold text-background-50 mb-1">欢乐合辑</h3>
                <p className="text-xs text-background-300">爆笑喜剧陪你开心每一天</p>
              </div>
            </div>

            {/* Item 6 */}
            <div className="group relative rounded-2xl overflow-hidden aspect-[4/3] cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=Nature%20documentary%20collage%20with%20wildlife%20and%20stunning%20landscapes%2C%20warm%20natural%20golden%20lighting%2C%20cinematic%20wide%20angle%20shots%2C%20BBC%20style%20professional%20photography%2C%20clean%20composition%2C%20documentary%20film%20aesthetic&width=800&height=600&seq=carousel-06&orientation=landscape"
                alt="纪录万象专题 - 西瓜影视焦点专题"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-primary-500/90 text-background-50 text-[10px] font-medium mb-2 whitespace-nowrap">高分佳作</span>
                <h3 className="font-heading text-lg font-bold text-background-50 mb-1">纪录万象</h3>
                <p className="text-xs text-background-300">BBC国家地理高分纪录片精选</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}